import { ReactNode } from 'react';

interface IFieldLayout {
  children: ReactNode;
  fieldStyle?: string;
}
const FieldLayout = ({ children, fieldStyle }: IFieldLayout) => {
  return (
    <div className={`col-12 ${fieldStyle}`}>
      <div className="form-group mb-3">{children}</div>
    </div>
  );
};
export default FieldLayout;
